import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthKeycloakGuard } from './_auth/keycloack-auth.guard';
import { roles } from './_constants/roles';
import { RolesConfigResolverService } from './_helpers/roles-config-resolver.service';
import { FaqComponent } from './_modules/shared/_components/faq/faq.component';
import { FinancialHomeComponent } from './_modules/shared/_components/financial-home/financial-home.component';
import { PageNotFoundComponent } from './_modules/shared/_components/page-not-found/page-not-found.component';
import { RoleNotFoundComponent } from './_modules/shared/_components/role-not-found/role-not-found.component';
import { RoleRequestComponent } from './_modules/shared/_components/role-request/role-request.component';
import { UnauthorisedAccessPageComponent } from './_modules/shared/_components/unauthorised-access-page/unauthorised-access-page.component';

export const routes: Routes = [
    { path: '', redirectTo: 'main/dashboard', pathMatch: 'full' },
    {
        path: 'main',
        component: FinancialHomeComponent,
        canActivate: [AuthKeycloakGuard],
        data: { allowedRoles: [roles.ALL] },
        resolve: { isRoleConfigured: RolesConfigResolverService },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('./_modules/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
            },
            {
                path: 'lakhpati-didi',
                loadChildren: () =>
                    import('./_modules/lakhpati-didi/lakhpati-didi.module').then(
                        (m) => m.LakhpatiDidiModule
                    ),
            },
            {
                path: 'aajeevika',
                loadChildren: () =>
                    import('./_modules/aajeevika/aajeevika.module').then(
                        (m) => m.AajeevikaModule
                    ),
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('./_modules/profile/profile.module').then(
                        (m) => m.ProfileModule
                    ),
            },
            {
                path: 'reports',
                loadChildren: () =>
                    import('./_modules/reports/reports.module').then(
                        (m) => m.ReportsModule
                    ),
            },
            {
                path: 'role-not-found',
                component: RoleNotFoundComponent,
                data: { allowedRoles: [roles.ALL] },
            },
            {
                path: 'role-request',
                component: RoleRequestComponent,
                data: { allowedRoles: [roles.ALL] },
            },
            {
                path: 'faq',
                component: FaqComponent,
                data: { allowedRoles: [roles.ALL] },
            },
            {
                path: 'transaction',
                loadChildren: () =>
                    import('./_modules/transaction/transaction.module').then(
                        (m) => m.TransactionModule
                    ),
            },
            {
                path: 'user-mapping',
                loadChildren: async () =>
                    (
                        await import('./_modules/user-mapping/user-mapping.module')
                    ).UserMappingModule,
            },
            {
                path: 'shg-meeting',
                loadChildren: async () =>
                    (
                        await import('./_modules/shg/shg-meeting/shg-meeting.module')
                    ).ShgMeetingModule,
            },
            {
                path: 'vo-meeting',
                loadChildren: async () =>
                    (await import('./_modules/vo/vo-meeting/vo-meeting.module'))
                        .VoMeetingModule,
            },
            {
                path: 'unauthorised-access',
                component: UnauthorisedAccessPageComponent,
            },
        ],
    },
    { path: 'unauthorised-access', component: UnauthorisedAccessPageComponent },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
